import React from 'react';
import { Redirect } from 'react-router-dom';

export default function S_DefaultPage() {
    return <Redirect to="/clients" />;
}
